import ServiceExec from '@/common/utils/ServiceExec';
import { anniversary, memorial } from '@/common/service/apiList';
import { asFormData, isEmpty, REMOVE_EMPTY_PARAMS } from '@/common/utils/Util';
import { cloneDeep } from 'lodash';
import store from '@/store';
import { MEMORIAL_TYPE } from '@/common/constants/ConstCode';

const andersenPrefix = '/api/andersen';
const commentPrefix = '/api/andersen/comment';
const alivePrefix = '/api/andersen/alive';

const { getAnniversary } = anniversary;

export default {
  async getDetail({ commit, getters, state }, andersenNo) {
    const { data, status } = await ServiceExec.get(andersenPrefix + `/${andersenNo}`);
    if (ServiceExec.status.OK !== status) return;
    commit('setDetail', data ?? '');
  },

  async getComment({ commit, getters, state }, andersenNo) {
    const condition = getters['getCommentCondition'];
    const pageInfo = getters['getPageInfo'];

    if (condition.page > pageInfo.totalPage) return false;

    condition.andersenNo = andersenNo;
    const { data, status } = await ServiceExec.get(commentPrefix + '/list', {
      ...condition
    });
    if (status !== ServiceExec.status.OK) return false;

    commit('setCommentPage', condition.page + 1);
    commit('setPageInfo', data.pageInfo);
    commit('setCommentList', data.list ?? []);
  },

  async pushComment({ commit, getters, state }, payload) {
    const reqData = cloneDeep(payload);

    const { status, data } = await ServiceExec.post(commentPrefix + '/send', reqData);
    if (status !== ServiceExec.status.OK) return false;
    commit('appendComment', data);
  },

  async deleteMemorial({ commit, getters, state }, memorialNo) {
    const { status } = await ServiceExec.patch(deleteMemorial + memorialNo);
    return status === ServiceExec.status.OK;
  },

  async save({ commit, getters, state }, payload) {
    const userData = store.getters['user/getUserData'];
    const stepFour = cloneDeep(payload);

    if (stepFour.isProductImage) delete stepFour.backgroundRawFile;

    const register = getters['getRegister'];

    Object.assign(register.step3, stepFour);

    register.step3.userNo = userData.userNo;

    for (let step2 of register.step2) {
      delete step2?.imageFile;
      delete step2?.preViewImage;
    }

    const reqData = asFormData({
      ...register.step1,
      deadList: register.step1,
      anniversaryList: register.step2,
      ...register.step3
    });

    const { status, data } = await ServiceExec.multiPost(andersenPrefix + '/save', reqData);
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  /**
   * 추모관 수정
   * @param commit
   * @param getters
   * @param state
   * @param stepFourData
   * @returns {Promise<boolean>}
   */
  async edit({ commit, getters, state }, stepFourData) {
    const { userNo } = store.getters['user/getUserData'];
    const stepFour = cloneDeep(stepFourData);

    const register = cloneDeep(getters['getRegister']);

    Object.assign(register.step4, stepFour);
    register.step1.isInside = MEMORIAL_TYPE.INSIDE === register.step1.memorialType;
    register.step4.userNo = userNo;

    for (let step2 of register.step2) {
      delete step2?.imageFile;
      delete step2?.preViewImage;
      delete step2?.file;
    }
    const reqData = asFormData(
      REMOVE_EMPTY_PARAMS({
        ...register.step1,
        deadList: register.step2,
        anniversaryList: register.step3,
        ...register.step4
      })
    );

    const { status } = await ServiceExec.multiPut(editMemorial, reqData);
    return status === ServiceExec.status.OK;
  },

  async getAliveList({ commit, getters, state }, andersenNo) {
    const condition = getters['getAliveCondition'];
    condition.andersenNo = andersenNo;
    const { data, status } = await ServiceExec.get(alivePrefix + '/list', condition);
    if (ServiceExec.status.OK !== status) return;
    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setAliveList', data.list ?? []);
  },

  async getAliveDetail({ commit, getters, state }, aliveNo) {
    const { data, status } = await ServiceExec.get(alivePrefix + `/${aliveNo}`);
    if (ServiceExec.status.OK !== status) return;
    commit('setAliveDetail', data ?? '');
  },

  async createAlive({ commit, getters, state }, payload) {
    const { userNo } = store.getters['user/getUserData'];
    const reqParams = cloneDeep({ ...payload, userNo });
    const { status } = await ServiceExec.multiPost(alivePrefix + '/save', asFormData(REMOVE_EMPTY_PARAMS(reqParams)));
    return ServiceExec.status.OK === status;
  },

  async updateAlive({ commit, getters, state }, payload) {
    const { userNo } = store.getters['user/getUserData'];
    const reqParams = cloneDeep({ ...payload, userNo });
    const { status } = await ServiceExec.multiPut(alivePrefix + '/update', asFormData(REMOVE_EMPTY_PARAMS(reqParams)));
    return ServiceExec.status.OK === status;
  },

  /**
   * 생전모습 삭제
   * @param payload
   * - aliveNo 생전모습번호
   * - userNo 유저번호
   * @return {Promise<boolean>}
   */
  async deleteAlive({ state }, payload) {
    const { status } = await ServiceExec.delete(alivePrefix + `/${payload.aliveNo}`);
    return status === ServiceExec.status.OK;
  },

  async getBackground({ commit, getters, state }) {
    const userData = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get('/api/shop/' + userData.userNo + '/ANDERSEN_BG_IMAGE');
    if (ServiceExec.status.OK !== status) return;
    commit('setBackground', data ?? '');
  },

  async getFrame({ commit, getters, state }) {
    const { data, status } = await ServiceExec.get(getFrame);
    if (ServiceExec.status.OK !== status) return;
    commit('setFrame', data ?? '');
  },

  async fetchAnniversary({ commit, getters, state }, memorialNo) {
    const { data, status } = await ServiceExec.get(getAnniversary(memorialNo));
    if (ServiceExec.status.OK !== status) return;
    commit('setAnniversaryList', data ?? '');
  }
};
